import type { ReadableDefinition, ReadableSite } from '../../shared/game/story-types.js';
import type { ItemDefinition } from '../../shared/game/supply-types.js';
import { saintCendreLog, saintCendreLogItem } from './saint-cendre-log.js';

export const readables: ReadableDefinition[] = [saintCendreLog];
/** Readable items, appended to the item catalog. */
export const readableItems: ItemDefinition[] = [saintCendreLogItem];
/** Readables lying or hanging in the world. */
export const readableSites: ReadableSite[] = [
  // On the shingle at the water's edge, in sight of the Drowned Hull standing in the shallows at (-282, 70).
  { id: 'saint-cendre-log-site', name: 'Captain’s log', x: -247, z: 68, readableId: saintCendreLog.id },
];
